module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-product-edit', {
    attrs: {
      "product": _vm.product,
      "images": _vm.images
    }
  }, [(_vm.salesChannel.length) ? _c('panel', {
    attrs: {
      "slot": "before-price",
      "title": "Preço por canal de venda"
    },
    slot: "before-price"
  }, _vm._l((_vm.salesChannel), function(saleChannel) {
    return _c('panel', {
      staticClass: "blue-panel",
      attrs: {
        "title": saleChannel.label,
        "useAcordion": true,
        "blockToggle": !saleChannel.active
      }
    }, [_c('label', {
      staticClass: "form-switch",
      attrs: {
        "slot": "header-right"
      },
      slot: "header-right"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (saleChannel.active),
        expression: "saleChannel.active"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(saleChannel.active) ? _vm._i(saleChannel.active, null) > -1 : (saleChannel.active)
      },
      on: {
        "change": function($event) {
          var $$a = saleChannel.active,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(saleChannel, "active", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(saleChannel, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(saleChannel, "active", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "form-switch__indicator"
    })]), _vm._v(" "), _c('panel', [_c('div', {
      staticClass: "l-row"
    }, [_c('div', {
      staticClass: "l-col-12@md"
    }, [_c('product-price', {
      attrs: {
        "input": saleChannel.price,
        "module": _vm.product.source,
        "sku": _vm.product.sku
      }
    })], 1)])])], 1)
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-090b3ff8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/skyhub/ProductEdit.vue
// module id = 2886
// module chunks = 0